import { useEffect } from 'react';
import { history } from 'umi';
import { SLASH_G_POP } from '@gp/constants/const';

import type { IMetricsCategory } from '@gp/types/metrics';

export default function useMetricsUpdateQueryParams(activeId: IMetricsCategory) {
  useEffect(() => {
    const searchParams = new URLSearchParams({ tab: activeId });
    const searchParamsStr = searchParams.toString();
    const path = !searchParamsStr ? `${SLASH_G_POP}/Metrics` : `${SLASH_G_POP}/Metrics?${searchParamsStr}`;
    history.replace(path);
  }, [activeId]);
}
